import { createSlice, PayloadAction} from "@reduxjs/toolkit";
import {RequestError} from "../../Entity/RequestError";
import {AppThunk} from "../../../app/store";
import {ProductCtaAssociation} from "../../Entity/Product";
import {getProductAssociationTypesRep} from "../../Repository/ProductAssociationTypesRepository";

interface ProductAssociationTypesState {
  isRequesting: boolean,
  isRequestSuccess: boolean,
  isRequestFailed: boolean,
  error: RequestError | null,
  productAssociationTypes: ProductCtaAssociation[]|null,
}

const ProductAssociationTypesInitialState: ProductAssociationTypesState = {
  isRequesting: false,
  isRequestSuccess: false,
  isRequestFailed: false,
  productAssociationTypes: null,
  error: null,
}

function startRequest(state: ProductAssociationTypesState) {
  state.isRequesting = true;
  state.isRequestFailed = false;
  state.productAssociationTypes = null;
}

function registerFailed(state: ProductAssociationTypesState, action: PayloadAction<any>) {
  state.isRequesting = false;
  state.isRequestSuccess = false;
  state.isRequestFailed = true;
  state.error = action.payload;
}
function registerSuccess(state: ProductAssociationTypesState, action: PayloadAction<any>) {
  state.isRequesting = false;
  state.isRequestSuccess = true;
  state.isRequestFailed = false;
  state.error = null;
  state.productAssociationTypes = action.payload["hydra:member"] as ProductCtaAssociation[];
  state.error = null;
  document.dispatchEvent(new Event("onDatatablesDataReceived"));
}

const productAssociationTypesSlice = createSlice({
    name: 'productAssociationTypes',
    initialState: ProductAssociationTypesInitialState,
    reducers: {
      productAssociationTypesStartRequest: startRequest,
      productAssociationTypesSuccess: registerSuccess,
      productAssociationTypesFailed: registerFailed,
    }
  }
)

export const {
  productAssociationTypesStartRequest,
  productAssociationTypesSuccess,
  productAssociationTypesFailed,
} = productAssociationTypesSlice.actions;

export default productAssociationTypesSlice.reducer;

export const getProductAssociationTypes = (locale:string,productCode:string): AppThunk => async dispatch => {
  try {
    dispatch(productAssociationTypesStartRequest());
    const newsApiResponse = await getProductAssociationTypesRep(locale, productCode);
    dispatch(productAssociationTypesSuccess(newsApiResponse));
  } catch (err) {
    dispatch(productAssociationTypesFailed(err));
  }
}
